// extracted by mini-css-extract-plugin
export default {"tag":"TagItem_tag__GuT-f","selected":"TagItem_selected__OQFbi"};